export default __webpack_public_path__ + "static/media/rubber-stamp.34aff853.png";